import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { HydraulicManufacturerRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: HydraulicManufacturerRow[];
  loading?: boolean;
};

const HydraulicManufacturerTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "hydraulicWallManufacturerId",
        label: t("HYDRAULIC_MANUFACTURER.TABLE.CODE"),
        align: "right",
        width: "50%",
        minWidth: "50%",
        format: (row: HydraulicManufacturerRow) => (
          <span className={styles.textCell}>
            {row.hydraulicWallManufacturerId}
          </span>
        ),
      },
      {
        id: "hydraulicWallManufacturerName",
        label: t("HYDRAULIC_MANUFACTURER.TABLE.DESCRIPTION"),
        align: "right",
        width: "50%",
        minWidth: "50%",
        format: (row: HydraulicManufacturerRow) => (
          <span className={styles.textCell}>
            {row.hydraulicWallManufacturerName}
          </span>
        ),
      },
    ],
    [styles, t],
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("HYDRAULIC_MANUFACTURER.EMPTY")}
      />
    </div>
  );
};

export default HydraulicManufacturerTable;
